import React, {} from 'react'
import Page from 'src/components/Page'
import {
  makeStyles,
  Grid,
  Typography,
  Button,
} from '@material-ui/core'
import {
  Route,
  Routes,
  useLocation,
  Link,
} from 'react-router-dom'
import { ArrowLeft } from 'react-feather'
import Exam from 'src/components/Exam'
import { Package } from './Package'
import PackageList from './PackageList'
import PackageForm from './PackageForm'
import DiscTest from './DiscTest'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
  valueCell: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'right',
    },
  },
  icons: {
    color: '#b2b6c0',
    transition: '0.2s',
    '&:hover': {
      color: '#f39994',
    },
  },
}))

export const Packages = () => {
  const classes = useStyle()
  const { pathname } = useLocation()

  return (
    <Page
      className={classes.root}
      title="فهرست پکیج ها"
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          <Typography variant="h3" component="h3">فهرست پکیج ها</Typography>

          {pathname === '/app/exams/packages'
            ? (
              <Link to="./add">
                <Button variant="contained" style={{ borderRadius: '20px' }} color="primary">
                  {/* <User size={16} className={classes.icon} /> */}
                  ایجاد پکیج جدید
                </Button>
              </Link>
            )
            : (
              <Link to="../packages">
                <Button>
                  بازگشت
                  <ArrowLeft />
                </Button>
              </Link>
            )}
        </Grid>

        <Routes>
          <Route path="/" element={<PackageList />} />
          <Route path="/add" element={<PackageForm />} />
          <Route path="/edit/:packageId" element={<PackageForm />} />
          <Route path="/:packageId" element={<Package />} />

          <Route path="/:packageId/:examId" element={<DiscTest />} />
          <Route path="/package/:packageName/exam/:examName" element={<DiscTest />} />

          <Route path="/exam/:userExamId/" element={<Exam />} />
          <Route path="/exam/:userExamId/:first" element={<Exam />} />
          <Route path="/exam/:userExamId/:first/:after" element={<Exam />} />
        </Routes>
      </Grid>

    </Page>
  )
}

export default Packages
